import { DatePipe, KeyValue } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { GamesService, NavigationContext } from '../../../services/games.service';
import { Component, HostListener, OnInit, Input, Renderer2, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { GamesFilterPipe } from '../../../custom-pipes/games-filter.pipe';
import { MarketplaceService } from '../../../services/marketplace.service';
import { AfterViewInit } from 'cv-ng-metadata/core';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import moment from 'moment';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { GameType } from '../../../models/games.model';
import { PointStorePermissionService } from 'src/app/gamification/marketplace/admin/services/point-store-permission.service';
import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'cv-games-landing',
  templateUrl: './games-landing.component.html',
  styleUrls: ['./games-landing.component.scss']
})
export class GamesLandingComponent implements OnInit, AfterViewInit {
  public localizationDic: Map<string, string> = new Map();
  gs: any = null;
  viewType: number = 0; //0 -> GridView | 1-> TableView
  inAddEdit: boolean = false;
  scrollBottom: number = 0;
  lastScrollPosition: number = 0;

  html: string = '';
  counter: number = 0;
  popoverIndex: number[] = [];

  //Variables for filtering functionality
  searchTerm: string = '';
  gameStates: boolean[] = [true, false];
  intervals: boolean[] = [false, false, false];
  gameTypes: boolean[] = [false, false, false, false, false, false, false, false, false];

  stateOptions = [
    {
      name: "Active",
      value: "0"
    }
  ];
  stateSelection = [{
    name: "Active",
    value: "0"
  }];
  typeSelection = [];
  intervalSelection = [];
  typeOptions = [];
  intervalsOptions = [];
  selectedTags = [];
  omnibarDynamicHeight: string;

  isFilterOpen: boolean = false;
  
  //Filtering params implemented on custom pipe
  gStateParam: string = "10";
  gIntervalParam: string = "000";
  gTypeParam: string = "00000000";
  filteredData: any[];
  isFiltering: boolean = false;
  loadingData: boolean = false;

  private scrollListener: () => void;
  private searchSubject: Subject<string> = new Subject();
  private navigationSubscription: Subscription;
  
  @ViewChild('gamesLanding') gamesLandingContainer: ElementRef;
  @ViewChild('omnibar', { static: true }) omnibar: ElementRef;
  @Input() isCxone: boolean = false;

  constructor(
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer,
    private gamesService: GamesService,
    private marketplaceService: MarketplaceService,
    private dialogService: CvDialogService,
    private gamesFilter: GamesFilterPipe,
    private renderer: Renderer2,
    private customDialogService: CvCustomDialogService,
    private localizationService: CVLocalizationService,
    private cvNumberLocalizePipe: CvNumberLocalizePipe,
    private cdr: ChangeDetectorRef,
    private pointStorePermissionService: PointStorePermissionService,
    private cvConfigurationService: CvConfigurationService
  ) {
    this.gs = this.gamesService.data;
  }

  async ngOnInit() {
    await this.loadPermissionList();
    this.gs.gamesFolderStates = [];
    this.gamesService.getGamesFolders$().subscribe(item => { this.filterData() });
    this.gamesService.loadGamesLanding(false);
    this.marketplaceService.loadProducts(true);
    this.gs.loadGlimpseGamesLanding = true;
    this.localizationDic = await this.localizationService.GetSection("Games_Module");
    await this.localizationService.GetSection("Games");
    if (this.isCxone) {
      this.fillOptions();
      this.filteredData = undefined;
      this.searchSubject.pipe(debounceTime(300)).subscribe(() => {
        this.filterData();
      });
    }

    if (!this.isCxone) {
      this.gamesService.resetNavigation();
      this.handleNavigation();
    }
  }

  ngAfterViewInit(): void {
    if(this.isCxone){
      const element = this.gamesLandingContainer.nativeElement.parentElement;
      if (element) {
        this.scrollListener = this.renderer.listen(element, 'scroll', this.onCxoneScroll.bind(this));
      }
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    }
  }

  handleNavigation(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    this.navigationSubscription = this.gamesService.navigation$.subscribe((target) => { 
        if (!target) return;

        switch (target.type) {
            case 'edit':
                this.gamesService.pushContext(target.type);
                this.editGame(target.game, target.folder);
                break;
            case 'history':
                this.gamesService.pushContext(target.type);
                this.showGamesHistory(target.game);
                break;
            case 'back':
                this.gamesService.popContext();
                const from = this.gamesService.peekContext();
                this.gs.currentView = from === 'landing' ? 0 : 1;
                break;
        }
    });
  }

  fillOptions(): void {
    this.stateOptions = [
      { name: this.getLocalizationString('Active', 'Active'), value: "0" },
      { name: this.getLocalizationString('Inactive', 'Inactive'), value: "1" }
    ];
    this.onFilterStateChanged([this.stateOptions[0]]);
    this.typeOptions = Object.values(this.gs.gameTypes)
    .filter((type: any) => type > 0 && type != GameType.Percentile && (!this.isCxone || (this.isCxone && type < 9)))
    .sort(this.keyAscOrder)
    .map((type: any) => {
      return { name: this.gs.gameTypes.textFromValue(type), value: type };
    });
    const intervalLocalizations = {
      1: 'Daily',
      2: 'Weekly',
      3: 'Monthly'
    }
    this.intervalsOptions = Object.values(this.gs.gameIntervals)
    .filter((interval: any) => interval > 0)
    .sort(this.keyAscOrder)
    .map((interval: any) => {
      return { 
        name: this.localizationService.getCachedText('Games', intervalLocalizations[interval], intervalLocalizations[interval]), value: interval };
    });
  }

  toggleFilter(): void {
    this.isFilterOpen = !this.isFilterOpen;
  }
  
  ngOnDestroy(): void {
    this.gs.loadGlimpseGamesLanding = false;

    //Added this to make sure we are stopping the glimpservice once user is not in Games Landing or Overview.
    if (this.gs.loadTimeout && !this.gs.loadGlimpseOverview && !this.gs.loadGlimpseGamesLanding) {
      clearTimeout(this.gs.loadTimeout);
      this.gs.loadTimeout = null;
    }

    if(this.isCxone && this.scrollListener) {
        this.scrollListener();
    }

    if (this.isCxone) {
      this.searchSubject.unsubscribe();
      this.renderer.removeStyle(document.body, 'overflow');
    }

    if (!this.isCxone) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private onCxoneScroll(event: Event): void {
    const element = event.target as HTMLElement;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.scrollBottom = 3;
    } else {
      this.scrollBottom = 0;
    }
  }

  onDeleteAllTags(): void {
    this.onFilterStateChanged([]);
    this.onFilterTypeChanged([]);
    this.onFilterIntervalChanged([]);
  }

  onTagDeleted(tag: any): void {
    if (tag.id.startsWith('state-')) {
      this.stateSelection = this.stateSelection.filter((item: any) => parseInt(item.value) !== parseInt(tag.id.split('-')[1]));
      this.onFilterStateChanged(this.stateSelection);
    } else if (tag.id.startsWith('type-')) {
      this.typeSelection = this.typeSelection.filter((item: any) => parseInt(item.value) !== parseInt(tag.id.split('-')[1]) + 1);
      this.onFilterTypeChanged(this.typeSelection);
    } else if (tag.id.startsWith('interval-')) {
      this.intervalSelection = this.intervalSelection.filter((item: any) => parseInt(item.value) !== parseInt(tag.id.split('-')[1]) + 1);
      this.onFilterIntervalChanged(this.intervalSelection);
    }
    this.cdr.detectChanges();
  }

  getLocalizationString(key: string, defaultValue: string) {
    if (this.localizationDic) {
      if (this.localizationDic.has(key)) {
        return this.localizationDic.get(key);
      }
    }
    return defaultValue;
  }

  async newGameClicked(folderID?: number) {
    const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
      name: this.pointStorePermissionService.getCreatePermissionName(),
      pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
      newCXoneModalVersion: true
    }, !this.cvConfigurationService.isCxOne);
    if (!hasCreatePermission) {
      return;
    }
    this.lastScrollPosition = window.scrollY;
    this.gs.modified.New(folderID);
    this.inAddEdit = true;
    $(document).trigger(new jQuery.Event('Event.Games.Setup.New'));

    if (!this.isCxone) {
      this.gamesService.clearContext();
      this.gamesService.pushContext('landing');
      this.gamesService.pushContext('edit');
    }
  }

  async editGame(game: any, folder: any, from?: NavigationContext) {
    const hasEditPermission: boolean = await this.pointStorePermissionService.validatePermission({
      name: this.pointStorePermissionService.getEditPermissionName(),
      pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
      newCXoneModalVersion: true
    }, !this.cvConfigurationService.isCxOne);
    if (!hasEditPermission) {
      return;
    }
    this.lastScrollPosition = window.scrollY;
    this.gs.modified.Edit(game, folder);
    this.inAddEdit = true;
    $(document).trigger(new jQuery.Event('Event.Games.Setup.Edit'));

    if(!this.isCxone) {
      const stack = this.gamesService.getContextStack();
      const isExternalnavigation = stack.includes('edit');
      const forceClean = !isExternalnavigation || from === 'landing';

      if (forceClean) {
        this.gamesService.clearContext();
        this.gamesService.pushContext(from ?? 'landing');
        this.gamesService.pushContext('edit');
      }
    }
  }

  async copyGame(game: any, folder: any) {
    const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
      name: this.pointStorePermissionService.getCreatePermissionName(),
      pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
      newCXoneModalVersion: true
    }, !this.cvConfigurationService.isCxOne);
    if (!hasCreatePermission) {
      return;
    }
    this.lastScrollPosition = window.scrollY;
    this.gs.modified.Copy(game, folder);
    this.inAddEdit = true;
    $(document).trigger(new jQuery.Event('Event.Games.Setup.Copy'));
  }

  //Track functions for *ngFor
  folderIdentity(index: number, item: any): number {
    return item.FolderData.FolderID;
  }

  gameIdentity(index: number, item: any): number {
    return item.GameObject.underlyingRule.RuleID;
  }

  getTooltip(): string{
    return this.gamesService.getLocalizedMessage("Active_Games_Disclaimer", "Only active games on each interval end date will give payment.");
  }

  get gamesCount() {
    return this.loadingData ? 0 : (this.filteredData ?? []).reduce((counter, folder) => {
      return counter + folder.Games.length;
    }, 0);
  }

  getCombinedLabel(): string {
    const localizedGamesCount = this.cvNumberLocalizePipe.transform(this.gamesCount);
    const label = this.gamesCount === 1 ? this.getLocalizationString('Game', 'Game') : this.getLocalizationString('Games', 'Games');
    return `${localizedGamesCount} ${label}`;
  }

  gameAdded(game: any): void {
    // Format the date to remove the 'Z' suffix
    if (game.GameObject.Schedule && game.GameObject.Schedule.StartDate) {
      game.GameObject.Schedule.StartDate = this.formatDate(game.GameObject.Schedule.StartDate);
    }
    
    if (game.GameObject.Schedule && game.GameObject.Schedule.EndDate) {
      game.GameObject.Schedule.EndDate = this.formatDate(game.GameObject.Schedule.EndDate);
    }
    //Find folder this game belongs to, and push it to the games array
    var filtered = this.gs.GameFolders.filter((f: any) => { return f.FolderData.FolderID == game.GameObject.underlyingRule.FolderID });
    if (filtered != null && filtered.length == 1) {
      filtered[0].Games.push(game);
    } else {
      //Add folder
      this.gs.GameFolders.push({
        FolderData: {
          FolderID: game.GameObject.underlyingRule.FolderID,
          FolderName: game.GameObject.underlyingRule.RuleFolder,
          FolderDesc: "",
          FolderCategory: 1, //Games category
        },
        Games: [game]
      });
      this.gs.GameFolders.sort((a: any, b: any) => {
        if (a.FolderData.FolderName < b.FolderData.FolderName) return -1;
        if (a.FolderData.FolderName > b.FolderData.FolderName) return 1;
        return 0;
      });
    }

    // refresh data with the new game in folders
    this.filterData();
    this.inAddEdit = false;
  }
  
  private formatDate(dateString: string): string {
    if (!dateString) return null;
    // This method extracts the date and time value from a UTC string without timezone conversion for newly created games
    return moment.utc(dateString).format('YYYY-MM-DDTHH:mm:ss');
  }

  gameChanged = function (game: any): void {
    var filtered = this.gs.GameFolders.filter((f: any) => { return f.FolderData.FolderID == game.GameObject.underlyingRule.FolderID });
    if (filtered != null && filtered.length == 1) {
      var match = filtered[0].Games.filter((g: any) => { return g.GameObject.underlyingRule.RuleID == game.GameObject.underlyingRule.RuleID });
      if (match != null && match.length > 0) {
        match[0].GameObject = game.GameObject;
      } else {
        //Remove from the previous one Folder
        this._removeGameFromList(game, true);

        //FolderId was changed
        filtered[0].Games.push(game);
      }
    } else {
      //Remove from the previous one Folder
      this._removeGameFromList(game, true);

      //Insert folder
      this.gs.GameFolders.push({
        FolderData: {
          FolderID: game.GameObject.underlyingRule.FolderID,
          FolderName: game.GameObject.underlyingRule.RuleFolder,
          FolderDesc: "",
          FolderCategory: 1,//Games category
        },
        Games: [game]
      });
      this.gs.GameFolders.sort((a: any, b: any) => {
        if (a.FolderData.FolderName < b.FolderData.FolderName) return -1;
        if (a.FolderData.FolderName > b.FolderData.FolderName) return 1;
        return 0;
      });
    }
    this.filterData();
    this.inAddEdit = false;
    if (!this.isCxone) {
      this.gamesService.navigateTo({ type: 'back' });
    }
  }

  async deleteGame(event: any, game: any) {
    const hasEditPermission: boolean = await this.pointStorePermissionService.validatePermission({
      name: this.pointStorePermissionService.getEditPermissionName(),
      pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
      newCXoneModalVersion: true
    }, !this.cvConfigurationService.isCxOne);
    if (!hasEditPermission) {
      return;
    }

    if (!this.isCxone) {
      setTimeout(() => {
        this.dialogService.showConfirmDialog(
          this.gamesService.getLocalizedMessage("Confirm_Inactive_Title", "Confirm Make Inactive"),
          this.gamesService.getLocalizedMessage("Confirm_Inactive_Message", "Are you sure you want to make inactive this game? Only active games on each interval end date will give payment."),
          false,
          () => this._performDeleteGame(game)
        );
      }, 300);
    } else {
      const modalOptions: NgbModalOptions = {
        keyboard: false,
        backdrop: "static",
        centered: true,
        windowClass: "cxone-modal-games",
      };
      this.customDialogService.showDialog(
        this.gamesService.getLocalizedMessage("Confirm_Deactivate_Game", "Deactivate Game?"),
        `<p class='modal-body-text'>${this.gamesService.getLocalizedMessage("Payment_Warning_Game", "Payment will be processed only for the active games on each interval end date.")}</p>`,
        14,
        this.gamesService.getLocalizedMessage("No", "No"),
        this.gamesService.getLocalizedMessage("Deactivate", "Deactivate"),
        true,
        () => this._performDeleteGame(game),
        () => {},
        "cxone-deactivate-modal",
        true,
        modalOptions
      );
    }

    if (event != null)
      event.stopPropagation(); //Prevent from propagating to the other events, such as edit game
  }

  _performDeleteGame(game: any): void {
    this.gamesService.deleteGame(game).then(
      (result) => { this._removeGameFromList(game) },
      (error) => { showErrorMessage(this.gamesService.getLocalizedMessage("Error_Deleting_Game", "Error Deleting Game") + ": " + error.data.message) }
    );
  }

  _removeGameFromList(game: any, removeFromObject?: any): boolean {
    let matchFound = false;

    for (var i = 0; i < this.gs.GameFolders.length; i++) {
      for (var ii = 0; ii < this.gs.GameFolders[i].Games.length; ii++) {
        if (this.gs.GameFolders[i].Games[ii].GameObject.underlyingRule.RuleID == game.GameObject.underlyingRule.RuleID) {
          this.gs.GameFolders[i].Games[ii].GameObject.underlyingRule.Active = false;
          this.gs.GameFolders[i].Games[ii].GameObject.isActive = false;
          this.gs.GameFolders[i].Games[ii].GameObject.isRunning = false;
          this.gs.GameFolders[i].Games[ii].GameObject.isActiveText = "Deactivated on " + this.datePipe.transform(new Date(), CVAngularDateFormat);

          if (removeFromObject) {
            this.gs.GameFolders[i].Games.splice(ii, 1);
          }

          var indexGame = this.gs.games.findIndex(function (g: any) { return g.underlyingRule.RuleID == game.GameObject.underlyingRule.RuleID });
          this.gs.games.splice(indexGame, 1);

          //Include the deactivated game into the inactiveGames.
          if (this.gs.inactiveGames.length > 0) {
            var Folder = this.gs.inactiveGames.find((element: any) => element.FolderData.FolderID == this.gs.GameFolders[i].FolderData.FolderID);
            var game = Folder.Games.find((game: any) => game?.underlyingRule?.RuleID == game.GameObject.underlyingRule.RuleID);

            if (!game) {
              Folder.Games.push(this.gs.GameFolders[i].Games[ii]);
            }
          }

          matchFound = true;
          //Update future Table View
          //$scope.$broadcast("Event.Games.Setup.UpdateFromTable");
          break;
        }
      }

      if(matchFound){
        this.filterData();
        break;
      }
    }

    return matchFound;
  }

  async makeActive($event: any, game: any) {
    const hasEditPermission: boolean = await this.pointStorePermissionService.validatePermission({
      name: this.pointStorePermissionService.getEditPermissionName(),
      pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
      newCXoneModalVersion: true
    }, !this.cvConfigurationService.isCxOne);
    if (!hasEditPermission) {
      return;
    }

    if (!this.isCxone) {
        this.dialogService.showConfirmDialog(
            this.gamesService.getLocalizedMessage(
                "Confirm_Active_Title",
                "Confirm Make Active"
            ),
            this.gamesService.getLocalizedMessage(
                "Confirm_Active_Message",
                "Are you sure you want to make active this game?"
            ),
            false,
            () => this._performActiveGame(game)
        );
    } else {
        const modalOptions: NgbModalOptions = {
            keyboard: false,
            backdrop: "static",
            centered: true,
            windowClass: "cxone-modal-games",
        };
        this.customDialogService.showDialog(
            this.gamesService.getLocalizedMessage(
                "Confirm_Active_Title",
                "Confirm Make Active"
            ),
            `<p class='modal-body-text'>${this.gamesService.getLocalizedMessage(
                "Confirm_Active_Message",
                "Are you sure you want to make active this game?"
            )}</p>`,
            5,
            this.gamesService.getLocalizedMessage("No", "No"),
            this.gamesService.getLocalizedMessage("Yes", "Yes"),
            true,
            () => this._performActiveGame(game),
            () => {},
            "cxone-deactivate-modal",
            true,
            modalOptions
        );
    }

    if ($event != null)
      $event.stopPropagation(); //Prevent from propagating to the other events, such as edit game
  }

  _performActiveGame(game: any): void {
    this.gamesService.activateGame(game).then(
      (result) => { this._updateGameFromList(game); },
      (error) => { showErrorMessage(this.gamesService.getLocalizedMessage("Error_Deleting_Game", "Error Deleting Game") + ": " + error.data.message) }
    );
  }

  _updateGameFromList(game: any) {
    let matchFound = false;
    
    for (var i = 0; i < this.gs.GameFolders.length; i++) {
      for (var ii = 0; ii < this.gs.GameFolders[i].Games.length; ii++) {
        if (this.gs.GameFolders[i].Games[ii].GameObject.underlyingRule.RuleID == game.GameObject.underlyingRule.RuleID) {
          matchFound = true;

          this.gs.GameFolders[i].Games[ii].GameObject.underlyingRule.Active = true;
          this.gs.GameFolders[i].Games[ii].GameObject.isActive = true;

          let g = this.gs.GameFolders[i].Games[ii].GameObject;
          let endDate = null;

          if (g.underlyingRule.GameType !== 10){
            endDate = g.underlyingRule.EndDate != null ? new Date(g.underlyingRule.EndDate + "-06:00") : null;
          } else {
            if (g.BracketTournamentRounds && g.BracketTournamentRounds.length > 0){
              endDate = g.BracketTournamentRounds[0].EndDate != null ? new Date( g.BracketTournamentRounds[0].EndDate + "-06:00") : null;
            }
          }

          let now = new Date();

          if (g.underlyingRule.EndDate == null) {
            this.gs.GameFolders[i].Games[ii].GameObject.isRunning = true;
            this.gs.GameFolders[i].Games[ii].GameObject.isActiveText = "Continuously Running";
          } else if (endDate >= now) {
            this.gs.GameFolders[i].Games[ii].GameObject.isRunning = true;
            if (g.underlyingRule.GameType !== 10){
              this.gs.GameFolders[i].Games[ii].GameObject.isActiveText = "Runs till " + this.datePipe.transform(endDate, CVAngularDateFormat);
            } else {
              this.gs.GameFolders[i].Games[ii].GameObject.isActiveText = "Final will be on " + this.datePipe.transform(endDate, CVAngularDateFormat);
            }
          } else {
            this.gs.GameFolders[i].Games[ii].GameObject.isRunning = false;
            this.gs.GameFolders[i].Games[ii].GameObject.isActiveText = "Ended on " + this.datePipe.transform(endDate, CVAngularDateFormat);
          }
          //$scope.$broadcast("Event.Games.Setup.UpdateFromTable");
          break;
        }
      }

      if(matchFound){
        this.filterData();
        break;
      }
    }

    return matchFound;
  }

  getNumberFormat(param: any): number {
    return (param - 1);
  }

  keyAscOrder(a: KeyValue<any, number>, b: KeyValue<any, number>): number {
    return a.value < b.value ? -1 : (b.value < a.value ? 1 : 0);
  }

  filterData(): void {
    this.loadingData = true;

    //Changing filter data selection format
    this.gTypeParam = this.gameTypes.map(function(item){ return item ? 1 : 0 }).join("");
    this.gStateParam = this.gameStates.map(function(item){ return item ? 1 : 0 }).join("");
    this.gIntervalParam = this.intervals.map(function(item){ return item ? 1 : 0 }).join("");

    let tmpData = this.gamesFilter.transform(this.gs.GameFolders, this.searchTerm, this.gTypeParam, this.gStateParam, this.gIntervalParam);
    this.filteredData = tmpData;

    this.loadingData = false;
  }

  onSearchTermChange(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.searchSubject.next(searchTerm);
  }

  onFilterStateChanged(selection: any): void {
    this.gameStates = [false, false];
    selection.forEach((item: any) => {
      this.gameStates[item.value] = true;
    });

    if (this.gameStates[1] && this.gs.inactiveGames.length == 0) {
        this.gamesService.loadGamesLanding(true);
    }
  
    // Filter the existing selectedTags to remove entries with the prefix 'state-'
    this.selectedTags = this.selectedTags.filter(tag => !tag.id.startsWith('state-'));
  
    // Add new entries with the prefix 'state-'
    const newTags = selection.map(item => ({
      id: `state-${item.value}`,
      text: this.getLocalizationString('State', 'State'),
      subText: item.name
    }));

    this.stateSelection = selection;
  
    this.selectedTags = [...this.selectedTags, ...newTags];
    this.filterData();
  }
  
  onFilterTypeChanged(selection: any): void {
    this.gameTypes = [false, false, false, false, false, false, false, false, false];
    selection.forEach((item: any) => {
      this.gameTypes[item.value - 1] = true;
    });
  
    // Filter the existing selectedTags to remove entries with the prefix 'type-'
    this.selectedTags = this.selectedTags.filter(tag => !tag.id.startsWith('type-'));
  
    // Add new entries with the prefix 'type-'
    const newTags = selection.map(item => ({
      id: `type-${item.value - 1}`,
      text: this.getLocalizationString('Type', 'Type'),
      subText: item.name
    }));

    this.typeSelection = selection;
  
    this.selectedTags = [...this.selectedTags, ...newTags];
    this.filterData();
  }
  
  onFilterIntervalChanged(selection: any): void {
    this.intervals = [false, false, false];
    selection.forEach((item: any) => {
      this.intervals[item.value - 1] = true;
    });
  
    // Filter the existing selectedTags to remove entries with the prefix 'interval-'
    this.selectedTags = this.selectedTags.filter(tag => !tag.id.startsWith('interval-'));
  
    // Add new entries with the prefix 'interval-'
    const newTags = selection.map(item => ({
      id: `interval-${item.value - 1}`,
      text: this.getLocalizationString('Interval', 'Interval'),
      subText: item.name
    }));

    this.intervalSelection = selection;
  
    this.selectedTags = [...this.selectedTags, ...newTags];
    this.filterData();
  }

  displayFolderContent(folderID: number): void {
    this.gs.gamesFolderStates[folderID] = !this.gs.gamesFolderStates[folderID];
  }

  notifyTable(): void {
    //$scope.$broadcast("Event.Games.Setup.FilterFromTable");
  }

  loadInactiveGames(): void {
    if (this.gs.inactiveGames.length == 0) {
      this.gamesService.loadGamesLanding(true);
      this.filterData();
    }
  }

  showGamesHistory(game?: any, from?: NavigationContext): void {
    if (game != null) {
      this.gs.selectedGame = [];
      game.underlyingRule.isSelected = true;
      game.isSelected = true;
      this.gs.selectedGame.push(game);

      if(!this.isCxone) {
        const stack = this.gamesService.getContextStack();
        if (stack.length === 0 || stack[stack.length - 1] !== 'history') {
          this.gamesService.clearContext();
          this.gamesService.pushContext(from ?? 'landing');
          this.gamesService.pushContext('history');
        }
      }
    }

    this.gs.currentView = 1;
  }

  getPlacement(index: number): string {
    let value = null;
    if (this.popoverIndex[index] != null) {
      value = this.popoverIndex[index];
    } else {
      switch (this.counter) {
        case 0:
          this.counter++;
          this.popoverIndex[index] = 2;
          value = 2;
          break;
        case 1:
          if (window.innerWidth > 1199) {
            this.counter++;
            this.popoverIndex[index] = 2;
            value = 2;
          } else {
            this.counter = 0;
            this.popoverIndex[index] = 1;
            value = 1;
          }
          break;
        case 2:
          this.counter = 0;
          this.popoverIndex[index] = 1;
          value = 1;
          break;
      }
    }

    if(this.scrollBottom === 3){
      value = 3;
    }

    if (value == 1) {
      return 'left';
    }

    if (value == 3){
      return 'right left auto';
    } else {
      return 'right'
    }
  }

  getCxonePlacement(index: number): string {
    const windowWidth = window.innerWidth;
    let itemsPerRow: number;
  
    if (windowWidth >= 1600) {
        itemsPerRow = 4;
    } else if (windowWidth >= 1200) {
        itemsPerRow = 3;
    } else if (windowWidth >= 768) {
        itemsPerRow = 2;
    } else {
        itemsPerRow = 1;
    }
    
    if(this.scrollBottom === 3) {
      return 'right left auto';
    }

    if (index % itemsPerRow === 0) {
        return 'right auto';
    } else if ((index + 1) % itemsPerRow === 0) {
        return 'left auto';
    } else {
        return 'right left auto';
    }
  }

  @HostListener('window:scroll', ['$event'])
  private onScroll($event: Event): void {
    if (window.innerHeight + window.scrollY >=(document.documentElement.scrollHeight || window.innerHeight)) {
      this.scrollBottom = 3;
    }else {
      this.scrollBottom = 0;
    }
  }

  getPopoverTemplate(game: any): any {
    if (game != undefined && game.SelectedMetrics != undefined) {
      switch (game.underlyingRule.GameType) {
        case 1:
          this.html = this.getMultiplierMadnessTemplate(game);
          break;
        case 2:
          this.html = this.getTopDogTemplate(game);
          break;
        case 3:
          this.html = this.getBullseyeTemplate(game);
          break;
        case 5:
          this.html = this.getMilestoneTemplate(game);
          break;
        case 6:
          this.html = this.getConnect3Template(game);
          break;
        case 7:
          this.html = this.getConnectAllTemplate(game);
          break;
        case 8:
          this.html = this.getTopTeamTemplate(game);
          break;
        case 9:
          this.html = this.getRaffleTemplate(game);
          break;
        case 10:
          this.html = this.getBracketTournamentTemplate(game);
          break;
        default:
          this.html = "";
          break;
      }
    } else {
      this.html = "";
    }

    return this.sanitizer.bypassSecurityTrustHtml(this.html);
  }

  //#Region Game Templates
  getMultiplierMadnessTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorMultiplierMadness font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Multiplier_Madness", "Multiplier Madness") + '</div>'
      + '<div class="colorMultiplierMadness font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorMultiplierMadness font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorMultiplierMadness font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';
    
    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div></div>'
      + '<div class="d-flex flex-row justify-content-between">'
      + '<div class="d-flex flex-row justify-content-start">'
      + '<div class="colorMultiplierMadness font-size-14">' + (this.gamesService.getLocalizedMessage("Metric_Earnings", "Earnings per") + ' ' + game?.SelectedMetrics[0]?.abbrev) + '</div>'
      + '</div>'
      + '</div>'
      + '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
      + '<div class="col-6 p-0 d-flex pr-1 align-items-center">'
      + '<svg class="icon-24 fill-valyrianSteel"><use href="../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
      + '<span class="color-whaleTail font-size-14 pl-1">' + game.MultiplierMadnessRewards.coins + '</span>'
      + '</div>';
      if (!this.isCxone) {
        html += '<div class="col-6 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + game.MultiplierMadnessRewards.xp + '</span>'
        + '</div>';
      }
      html += '</div>'
      + '<div class="d-flex flex-row justify-content-between">'
      + '<div class="d-flex flex-row justify-content-start">'
      + '<div class="colorMultiplierMadness font-size-14">' + this.gamesService.getLocalizedMessage("Max_Payout", "Max Payout Possible") + '</div>'
      + '</div>'
      + '</div>'
      + '<div class="d-flex flex-row justify-content-between">'
      + '<div class="col-6 p-0 d-flex pr-1 align-items-center">'
      + '<svg class="icon-24 fill-valyrianSteel"><use href="../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
      + '<span class="color-whaleTail font-size-14 pl-1">' + (game.MultiplierMadnessRewards.maxCoinsPayout ? game.MultiplierMadnessRewards.maxCoinsPayout : '---') + '</span>'
      + '</div>'
      if (!this.isCxone) {
        html += '<div class="col-6 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (game.MultiplierMadnessRewards.maxXpPayout ? game.MultiplierMadnessRewards.maxXpPayout : '---') + '</span>'
        + '</div>';
      }
      html += '</div>'
      + '</div>';

    return html;
  }

  getTopDogTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorTopDog font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Top_Dog", "Top Dog") + '</div>'
      + '<div class="colorTopDog font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorTopDog font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorTopDog font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div></div>';

    for (var i = 0; i < game.TopDogRewards.length; i++) {
      html += '<div class="d-flex flex-row justify-content-between pb-1"><div class="d-flex flex-row justify-content-start">';
      switch (i) {
        case 0:
          html += '<div class="colorTopDog font-size-14">' + this.gamesService.getLocalizedMessage("First_Place", "First Place") + '</div>';
          break;
        case 1:
          html += '<div class="colorTopDog font-size-14">' + this.gamesService.getLocalizedMessage("Second_Place", "Second Place") + '</div>';
          break;
        case 2:
          html += '<div class="colorTopDog font-size-14">' + this.gamesService.getLocalizedMessage("Third_Place", "Third Place") + '</div>';
          break;
        default:
          html += '<div class="colorTopDog font-size-14">' + ((i + 1) + this.gamesService.getLocalizedMessage("Th_Symbol", "") + " " + this.gamesService.getLocalizedMessage("Place", "Place")) + '</div>';
          break;
      }

      html += '</div></div>'
        + '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
        + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (game.TopDogRewards[i].Coins != null ? game.TopDogRewards[i].Coins.rewardValue : '---') + '</span>'
        + '</div>'
        if (!this.isCxone) {
          html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (game.TopDogRewards[i].XP != null ? game.TopDogRewards[i].XP.rewardValue : '---') + '</span>'
          + '</div>';
        }
        html += '<div class="col-4 p-0 d-flex pr-1 align-items-center>'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBadgeUsingIndex(game, i) != null ? '<img src="' + this.getBadgeUsingIndex(game, i) + '" class="img-fluid" />' : '---') + '</span>'
        + '</div>'
        + ' </div>'
    }

    html += '</div>';
    return html;
  }

  getBullseyeTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorBullseye font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Bullseye", "Bullseye") + '</div>'
      + '<div class="colorBullseye font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorBullseye font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorBullseye font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';
    
    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) : "") + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) : "") + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber) : "") + '</span>';
          break;
      }
    }

    html += '</div></div>';

    for (var i = 0; i < game.BullseyeRewards.length; i++) {
      html += '<div class="d-flex flex-row justify-content-between pb-2">'
        + '<div class="d-flex flex-row justify-content-start">'
        + '<div class="bullseyeTargetIcon ' + ('tier' + (i + 1)) + ' mr-2" style="width: 42px; height: 42px; display: block; background-size: 40px; background-position: center"></div>'
        + '<div class="d-flex justify-content-between">';

      switch (i) {
        case 0:
          html += '<div class="d-flex align-items-center justify-content-between colorBullseye">' + this.gamesService.getLocalizedMessage("Bullseye_Prize", "Bullseye Prize") + '</div>';
          break;
        case 1:
          html += '<div class="d-flex align-items-center justify-content-between colorBullseye">' + this.gamesService.getLocalizedMessage("2nd_Ring", "2nd Ring") + '</div>';
          break;
        case 2:
          html += '<div class="d-flex align-items-center justify-content-between colorBullseye">' + this.gamesService.getLocalizedMessage("3rd_Ring", "3rd Ring") + '</div>';
          break;
        default:
          html += '<div class="d-flex align-items-center justify-content-between colorBullseye">' + ((i + 1) + this.gamesService.getLocalizedMessage("Th_Symbol", "th") + " " + this.gamesService.getLocalizedMessage("Ring_Prize", "Ring Prize")) + '</div>';
          break;
      }

      html += '</div></div></div>'
        + '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
        + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (game.BullseyeRewards[i].Coins != null ? game.BullseyeRewards[i].Coins.rewardValue : '---') + '</span>'
        + '</div>'
        if (!this.isCxone) {
          html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (game.BullseyeRewards[i].XP != null ? game.BullseyeRewards[i].XP.rewardValue : '---') + '</span>'
          + '</div>';
        }
        html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBadgeUsingIndex(game, i) != null ? '<img src="' + this.getBadgeUsingIndex(game, i) + '" class="img-fluid" />' : '---') + '</span>'
        + ' </div>'
        + '</div>';
    }

    html += '</div>';
    return html;
  }

  getMilestoneTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorMilestone font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Milestone", "Milestone") + '</div>'
      + '<div class="colorMilestone font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorMilestone font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + ' </div>'
      + ' <div class="d-flex flex-column justify-content-between">'
      + '<div class="colorMilestone font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }
    html += '</div></div>';

    game.MilestoneDetails.MilestoneThemeSelected = this.gamesService.getGameDefinitions().filter((gt) => { return gt.GameType == 5 })[0].Themes[game.MilestoneDetails.MilestoneThemeSelected.themeID - 1];
    
    html += '<!-- milestone map -->'
      + '<div class="container-fluid p-0">'
      + '<div class="MainContainer">'
      + '<div class="map_container" style="height:200px; background-image:url(\'' + game.MilestoneDetails.MilestoneThemeSelected.themePath + 'background.svg\')"></div>';

      for (var i = 0; i < 5; i++) {
        switch (i) {
          case 0:
            html += '<div class="map_item" style="height:200px; background-image:url(\'' + game.MilestoneDetails.MilestoneThemeSelected.themePath + 'check' + (i + 1) + '.svg\')"></div>';  
            break;
          case 1:
            if (game.MilestoneDetails.MilestoneQty > 3) {
              html += '<div class="map_item" style="height:200px; background-image:url(\'' + game.MilestoneDetails.MilestoneThemeSelected.themePath + 'check' + (i + 1) + '.svg\')"></div>';
            }
            break;
          case 2:
            if (game.MilestoneDetails.MilestoneQty > 2) {
              html += '<div class="map_item" style="height:200px; background-image:url(\'' + game.MilestoneDetails.MilestoneThemeSelected.themePath + 'check' + (i + 1) + '.svg\')"></div>';
            }
            break;
          case 3:
            if (game.MilestoneDetails.MilestoneQty == 5) {
              html += '<div class="map_item" style="height:200px; background-image:url(\'' + game.MilestoneDetails.MilestoneThemeSelected.themePath + 'check' + (i + 1) + '.svg\')"></div>';
            }
            break;  
          case 4:
            html += '<div class="map_item" style="height:200px; background-image:url(\'' + game.MilestoneDetails.MilestoneThemeSelected.themePath + 'check' + (i + 1) + '.svg\')"></div>';
            break;
        }
      }
      html += '</div></div>';
  
      let cont = 0;
      for (var i = game.MilestoneRewards.length - 1; i > 0; i--) {
        html += '<div class="d-flex flex-row justify-content-between pb-1">'
          + '<div class="d-flex flex-row justify-content-start">'
          + '<div class="colorMilestone font-size-14">' + this.gamesService.getLocalizedMessage("Milestone", "Milestone") + ' ' + (cont + 1) + ' - ' + game.MilestoneRewards[i].Target.Val1 + ' ' + game?.SelectedMetrics[0]?.abbrev + '</div>'
          + '</div>'
          + '</div>'
          + '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
          + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (game.MilestoneRewards[i].Coins != null ? game.MilestoneRewards[i].Coins.rewardValue : '---') + '</span>'
          + '</div>'
          if (!this.isCxone) {
            html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
            + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
            + '<span class="color-whaleTail font-size-14 pl-1">' + (game.MilestoneRewards[i].XP != null ? game.MilestoneRewards[i].XP.rewardValue : '---') + '</span>'
            + '</div>'
          }
          html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBadgeUsingIndex(game, i) != null ? '<img src="' + this.getBadgeUsingIndex(game, i) + '" class="img-fluid" />' : '---') + '</span>'
          + '</div>'
          + '</div>';
        cont++;
      }
  
      html += '</div>';
      return html;
  }

  getConnect3Template(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorConnect3 font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Connect3", "Connect 3") + '</div>'
      + '<div class="colorConnect3 font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorConnect3 font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorConnect3 font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + " " + "-" + " " + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div></div><div class="container col-12 p-2"><div class="row">';

    //Validate if the Game had a Free Space
    if (game.Connect3Positions.length == 8) {
      game.Connect3Positions.push({ position: 4, metric: { abbrev: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), name: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), metricID: -1, target: null } });
    }

    //Sort the Positions
    game.Connect3Positions.sort(function (a, b) { return (a.position > b.position) ? 1 : -1 });
    for (var i = 0; i < game.Connect3Positions.length; i++) {
      html += '<div class="col-4"><div class="card p-1 mx-n2 my-2 text-center font-size-12 ' + (game.Connect3Positions[i].metric.metricID != -1 ? 'cardConfiguredConnect3' : 'freeSpace') + '" style="height: 65px; pointer-events: none;">'
        + '<div class="d-flex flex-column justify-content-center align-items-center h-100">'
        + '<div class="metric-container">'
        + '<div class="font-size-12" style="color:' + (game.Connect3Positions[i].metric.metricID != -1 ? '#74617B' : '#FFFFFF') + '">' + (game.Connect3Positions[i].metric == null ? "Metric Goal" : game.Connect3Positions[i].metric.abbrev) + '</div>'
        + '<div class="font-size-12">'
        + (game.Connect3Positions[i].metric.metricID != -1 ? ((game.Connect3Positions[i].metric.direction === "0") ? '<' : '>') : '')
        + (game.Connect3Positions[i].metric.metricID != -1 ? this.formatterMetricData(game.Connect3Positions[i].metric.conversionType, game.Connect3Positions[i].targetObj.Target) : '')
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div></div>';
    }

    html += '</div></div></div>'
      + '<div class="colorConnect3 lato-regular font-size-14 p-2">' + this.gamesService.getLocalizedMessage("Connect3_Reward", "3-in-a-row Reward") + '</div>'
      + '<div class="d-flex flex-row justify-content-between align-items-center pb-1 lato-regular">'
      + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
      + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
      + '<span class="color-whaleTail font-size-14 pl-1">' + (game.Connect3Rewards.ThreeInRow.coins != null ? game.Connect3Rewards.ThreeInRow.coins : '---') + '</span>'
      + '</div>'
      if (!this.isCxone) {
        html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (game.Connect3Rewards.ThreeInRow.xp != null ? game.Connect3Rewards.ThreeInRow.xp : '---') + '</span>'
        + '</div>'
      }
      html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
      + '<svg class="icon-16 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
      + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBadgeImg(game) != null ? ('<img src="' + this.getBadgeImg(game) + '" class="img-fluid" />') : "---") + '</span>'
      + '</div>'
      + '</div>'
      + '</div>';

    return html;
  }

  getConnectAllTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorBlackout font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Blackout", "") + '</div>'
      + '<div class="colorBlackout font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorBlackout font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorBlackout font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span >';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div></div><div class="container col-12 p-2"><div class="row">';

    //Validate if the Game had a Free Space
    if (game.Connect3Positions.length == 8) {
      game.Connect3Positions.push({ position: 4, metric: { abbrev: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), name: this.gamesService.getLocalizedMessage("Free_Space", "Free Space"), metricID: -1, target: null } });
    }

    //Sort the Positions
    game.Connect3Positions.sort((a, b) => { return (a.position > b.position) ? 1 : -1 });
    for (var i = 0; i < game.Connect3Positions.length; i++) {
      html += '<div class="col-4"><div class="card p-1 mx-n2 my-2 text-center font-size-12 ' + (game.Connect3Positions[i].metric.metricID != -1 ? 'cardConfiguredBlackout' : 'freeSpaceBlackout') + '" style="height: 65px; pointer-events: none">'
        + '<div class="d-flex flex-column justify-content-center align-items-center h-100">'
        + '<div class="metric-container">'
        + '<div class="font-size-12" style="color:' + (game.Connect3Positions[i].metric.metricID != -1 ? '#0F5160' : '#FFFFFF') + '">' + (game.Connect3Positions[i].metric == null ? "Metric Goal" : game.Connect3Positions[i].metric.abbrev) + '</div>'
        + '<div class="font-size-12" style="color:#0F5160">'
        + (game.Connect3Positions[i].metric.metricID != -1 ? (game.Connect3Positions[i].metric.direction === "0") ? '<' : '>' : '')
        + (game.Connect3Positions[i].metric.metricID != -1 ? this.formatterMetricData(game.Connect3Positions[i].metric.conversionType, game.Connect3Positions[i].targetObj.Target) : '')
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div></div>';
    }

    html += '</div></div></div>'
      + '<div class="colorBlackout font-size-14 p-2 lato-regular">' + this.gamesService.getLocalizedMessage("Connect_All_Reward", "Connect All Reward") + '</div>'
      + '<div class="d-flex flex-row justify-content-between align-items-center pb-1 lato-regular">'
      + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
      + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
      + '<span class="color-whaleTail font-size-14 pl-1">' + (game.Connect3Rewards.Blackout.coins != null ? game.Connect3Rewards.Blackout.coins : '---') + '</span>'
      + '</div>'
      if (!this.isCxone) {
        html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (game.Connect3Rewards.Blackout.xp != null ? game.Connect3Rewards.Blackout.xp : '---') + '</span>'
        + '</div>';
      }
      html += '<div class="col-4 p-0 d-flex pr-1 align-items-center>'
      + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
      + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBadgeImg(game) != null ? ('<img src="' + this.getBadgeImg(game) + '" class="img-fluid" />') : '---') + '</span>'
      + '</div>'
      + '</div>'
      + '</div>';

    return html;
  }

  getTopTeamTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorTopTeam font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Top_Team", "Top Team") + '</div>'
      + '<div class="colorTopTeam font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorTopTeam font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorTopTeam font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div></div>';

    for (var i = 0; i < game.TopDogRewards.length; i++) {
      html += '<div class="d-flex flex-row justify-content-between pb-1">'
        + '<div class="d-flex flex-row justify-content-start">';

      switch (i) {
        case 0:
          html += '<div class="colorTopTeam font-size-14">' + this.gamesService.getLocalizedMessage("First_Place", "First Place") + '</div>';
          break;
        case 1:
          html += '<div class="colorTopTeam font-size-14">' + this.gamesService.getLocalizedMessage("Second_Place", "Second Place") + '</div>';
          break;
        case 2:
          html += '<div class="colorTopTeam font-size-14">' + this.gamesService.getLocalizedMessage("Third_Place", "Third Place") + '</div>';
          break;
        default:
          html += '<div class="colorTopTeam font-size-14">' + ((i + 1) + this.gamesService.getLocalizedMessage("Th_Symbol", "th") + ' ' + this.gamesService.getLocalizedMessage("Place", "Place")) + '</div>';
          break;
      }

      html += '</div>'
        + '</div>'
        + '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
        + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (game.TopDogRewards[i].Coins != null ? game.TopDogRewards[i].Coins.rewardValue : '---') + '</span>'
        + '</div>'
        if (!this.isCxone) {
          html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (game.TopDogRewards[i].XP != null ? game.TopDogRewards[i].XP.rewardValue : '---') + '</span>'
          + '</div>';
        }
        html += '<div class="col-4 p-0 d-flex pr-1 align-items-center>'
        + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
        + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBadgeUsingIndex(game, i) != null ? ('<img src="' + this.getBadgeUsingIndex(game, i) + '" class="img-fluid" />') : '---') + '</span>'
        + '</div>'
        + '</div>'
    }

    html += '</div>';
    return html;
  }

  getRaffleTemplate(game: any): string {
    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorRaffle font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Raffle", "Raffle") + '</div>'
      + '<div class="colorRaffle font-size-14 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency")+'</div>'
      + '<div class="color-whaleTail font-size-12 hide cxone-hide">'+this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.")+'</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorRaffle font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorRaffle font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div></div>';

    for (var i = 0; i < game.RaffleRewards.length; i++) {
      html += '<div class="d-flex flex-row justify-content-between pb-1"><div class="d-flex flex-row justify-content-start">';
      switch (i) {
        case 0:
          html += '<div class="colorRaffle font-size-14">' + this.gamesService.getLocalizedMessage("First_Prize", "1st Place Prize") + '</div>';
          break;
        case 1:
          html += '<div class="colorRaffle font-size-14">' + this.gamesService.getLocalizedMessage("Second_Prize", "2nd Place Prize") + '</div>';
          break;
        case 2:
          html += '<div class="colorRaffle font-size-14">' + this.gamesService.getLocalizedMessage("Third_Prize", "3rd Place Prize") + '</div>';
          break;
        default:
          html += '<div class="colorRaffle font-size-14">' + ((i + 1) + this.gamesService.getLocalizedMessage("Th_Symbol", "") + " " + this.gamesService.getLocalizedMessage("Place_Prize", "Place Prize")) + '</div>';
          break;
      }

      html += '</div></div>';

      if(game.RaffleRewards[i].isSystemReward){
        html += '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
            + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
            + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
            + '<span class="color-whaleTail font-size-14 pl-1">' + (game.RaffleRewards[i].Coins != null ? game.RaffleRewards[i].Coins.rewardValue : '---') + '</span>'
            + '</div>'
            + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
            + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
            + '<span class="color-whaleTail font-size-14 pl-1">' + (game.RaffleRewards[i].XP != null ? game.RaffleRewards[i].XP.rewardValue : '---') + '</span>'
            + '</div>'
            + ' </div>';
      } else {
        html += '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
            + '<span class="color-whaleTail font-size-14 pl-1">' + this.getCustomReward(game.RaffleRewards[i].Custom.rewardValue) + '</span>'
            + ' </div>';
      }
    }

    html += '</div>';
    return html;
  }

  getBracketTournamentTemplate(game: any): string {
    let participantsMap = {
      2: 4,
      3: 8,
      4: 16
    }

    let matchesMap = {
      2: 3,
      3: 7,
      4: 15
    }

    let totalParticipants = 0;
    let totalMatches = 0;
    if (game.BracketTournamentDetails !== null && game.BracketTournamentDetails.NumberOfRounds) {
      const rounds = game.BracketTournamentDetails.NumberOfRounds;
      totalParticipants = participantsMap[rounds];
      totalMatches = matchesMap[rounds];
    }

    let html = '<div class="d-flex flex-column lato-regular popover-template">'
      + '<div class="colorBracketTournament font-size-14">' + this.gamesService.getLocalizedMessage("Game_Type", "Game Type") + '</div>'
      + '<div class="font-size-12 color-whaleTail pb-1">' + this.gamesService.getLocalizedMessage("Bracket_Tournament", "Bracket Tournament") + '</div>'
      + '<div class="colorBracketTournament font-size-14 hide">' + this.gamesService.getLocalizedMessage("Game_Frequency", "Game Frequency") + '</div>'
      + '<div class="color-whaleTail font-size-12 hide">' + this.gamesService.getLocalizedMessage("Game_Frequency_Description", "This game runs every week on Monday, and Friday, from 11:00 to 14:00.") + '</div>'
      + '<div class="d-flex flex-row justify-content-between pb-1">'
      + '<div class="d-flex flex-column justify-content-start pr-2">'
      + '<div class="colorBracketTournament font-size-14 pr-1">' + this.gamesService.getLocalizedMessage("Metric", "Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12 pr-1">' + game?.SelectedMetrics[0]?.abbrev + '</div>'
      + '</div>'
      + '<div class="d-flex flex-column justify-content-between">'
      + '<div class="colorBracketTournament font-size-14">' + this.gamesService.getLocalizedMessage("Select_Qualifier", "Qualifier Metric") + '</div>'
      + '<div class="color-whaleTail font-size-12">' + (game.Qualifier != null ? game.Qualifier.abbrev : this.gamesService.getLocalizedMessage("None", "None")) + '</div>';

    if (game.QualifierLevels != null) {
      switch (game.QualifierLevels.comparerType) {
        case 1:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Greater_Than", "Greater Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 2:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Less_Than", "Less Than") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber)) : '') + '</span>';
          break;
        case 3:
          html += '<span class="color-whaleTail font-size-12">' + (game.Qualifier != null ? (this.gamesService.getLocalizedMessage("Between", "Between") + ': ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.leftNumber) + ' - ' + this.formatterMetricData(game.Qualifier.conversionType, game.QualifierLevels.rightNumber)) : '') + '</span>';
          break;
      }
    }

    html += '</div>'
         + '</div>'
         + '<div class="d-flex flex-column pb-1">'
         + '<div class="d-flex flex-row pb-1">'
         + '<div class="d-flex flex-column align-items-start mr-3">'
         + '<div class="colorBracketTournament font-size-14">' + this.gamesService.getLocalizedMessage("Players", "Players") + '</div>'
         + '<div class="color-whaleTail font-size-12">' + (game.BracketTournamentDetails != null ? totalParticipants : this.gamesService.getLocalizedMessage("None", "None")) + '</div>'
         + '</div>'
         + '</div>'
         + '<div class="d-flex flex-row justify-content-between">'
         + '<div class="d-flex flex-column align-items-start">'
         + '<div class="colorBracketTournament font-size-14">' + this.gamesService.getLocalizedMessage("Total_Matches", "Total Matches") + '</div>'
         + '<div class="color-whaleTail font-size-12">' + (game.BracketTournamentDetails != null ? totalMatches : this.gamesService.getLocalizedMessage("None", "None")) + '</div>'
         + '</div>'
         + '<div class="d-flex flex-column align-items-start mr-3">'
         + '<div class="colorBracketTournament font-size-14">' + this.gamesService.getLocalizedMessage("Total_Rounds", "Total Rounds") + '</div>'
         + '<div class="color-whaleTail font-size-12">' + (game.BracketTournamentDetails != null ? game.BracketTournamentDetails.NumberOfRounds : this.gamesService.getLocalizedMessage("None", "None")) + '</div>'
         + '</div>'
         + '</div>'
         + '</div>';

    html += '</div></div>';
    const rewards = game.BracketsTournamentRewards && game.BracketsTournamentRewards.length > 0 ? game.BracketsTournamentRewards.slice().reverse() : game.BracketsTournamentRewards;
    const allRounds = [
      this.gamesService.getLocalizedMessage("Round_1_Final", "Final"),
      this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals"),
      this.gamesService.getLocalizedMessage("Round_3_Quarter", "Quarter Finals"),
      this.gamesService.getLocalizedMessage("Round_4_Octaves", "Octaves")
    ];
    for (var i = 0; i < rewards.length; i++) {
      html += '<div class="d-flex flex-row justify-content-between pb-1"><div class="colorBracketTournament d-flex flex-row justify-content-start">';
      switch (rewards.length) {
        case 1:
          html += this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
          break;
        case 2:
          html += i === 0
            ? this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals")
            : this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
          break;
        case 3:
          html += i === 0
            ? this.gamesService.getLocalizedMessage("Round_3_Quarter", "Quarter Finals")
            : i === 1
              ? this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals")
              : this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
          break;
        case 4:
          html += i === 0
            ? this.gamesService.getLocalizedMessage("Round_4_Octaves", "Octaves")
            : i === 1
              ? this.gamesService.getLocalizedMessage("Round_3_Quarter", "Quarter Finals")
              : i === 2
                ? this.gamesService.getLocalizedMessage("Round_2_Semi_Finals", "Semi Finals")
                : this.gamesService.getLocalizedMessage("Round_1_Final", "Final");
          break;
        default:
          html += ((i + 1) + this.gamesService.getLocalizedMessage("Th_Symbol", "") + " " + this.gamesService.getLocalizedMessage("Place", "Place"));
          break;
      }

      html += '</div></div>';
      if (rewards[i].isSystemReward) {
        html += '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
          + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (rewards[i].Coins != null ? rewards[i].Coins.rewardValue : '---') + '</span>'
          + '</div>'
          + '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/xp.svg#xp"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (rewards[i].XP != null ? rewards[i].XP.rewardValue : '---') + '</span>'
          + '</div>';

        html += '<div class="col-4 p-0 d-flex pr-1 align-items-center">'
          + '<svg class="icon-24 fill-valyrianSteel"><use href="../../../App_Themes/clearview-default/icons/utility/badge.svg#badge"></use></svg>'
          + '<span class="color-whaleTail font-size-14 pl-1">' + (this.getBracketBadge(rewards[i]) != null ? '<img src="' + this.getBracketBadge(rewards[i]) + '" class="img-fluid" />' : '---') + '</span>'
          + ' </div>'
          + '</div>';
      } else {
        html += '<div class="d-flex flex-row justify-content-between align-items-center pb-1">'
          + '<span class="color-whaleTail font-size-14 pl-1">' + this.getCustomReward(rewards[i].Custom.rewardValue) + '</span>'
          + ' </div>';
      }
    }

    html += '</div>';
    return html;
  }

  getCustomReward(id: number): string {
    const product = this.marketplaceService.customRewards.filter((r: any) => { return r.PointStoreProductID == id })[0];
    return product != null ? product.Title : '';
  }

  formatterMetricData(conversionType: string, value: number): any {
    let formatted: any;
    if (value == undefined || value == null) value = 0;

    switch (conversionType) {
      case "1": //Second
        formatted = value;
        break;
      case "2": //Minute
        formatted = value / 60;
        break;
      case "3": //Hour
        formatted = Math.floor((value / 3600) * 100) / 100;
        break;
      case "4": //Time
        let hours = Math.floor(value / 3600);
        let minutes = Math.floor((value - (hours * 3600)) / 60);
        let seconds = (value - (hours * 3600) - (minutes * 60));

        let hh = (hours < 10) ? "0" + hours : hours;
        let mm = (minutes < 10) ? "0" + minutes : minutes;
        let ss = (seconds < 10) ? "0" + seconds : seconds;

        formatted = hh + ':' + mm + ':' + ss;
        break;
      case "5": //Percent
        formatted = (value * 100).toFixed(2);
        break;
      default:
        formatted = value;
        break;
    }

    return formatted;
  }

  getBadgeUsingIndex(game: any, index: number): string {
    let reward = null;
    
    if (game.TopDogRewards != null) {
      if (game.TopDogRewards.length > index) {
        if (game.TopDogRewards[index].Badge != undefined || game.TopDogRewards[index].Badge != null) {
          reward = game.TopDogRewards[index].Badge.rewardValue
        } else {
          reward = null;
        }
      }
    } // get 1st place reward
    else if (game.BullseyeRewards != null) { 
      reward = (game.BullseyeRewards.length != 0 && game.BullseyeRewards[index].Badge != null) ? game.BullseyeRewards[index].Badge.rewardValue : null; 
    }
    else if (game.MilestoneRewards != null) { 
      reward = (game.MilestoneRewards.length != 0 && game.MilestoneRewards[index].Badge != null) ? game.MilestoneRewards[index].Badge.rewardValue : null; 
    }

    if (reward == null || reward == 0) return null;
    return "../Admin/ImageResizer.aspx?imgid=" + reward + "&w=24&h=24";
  }

  getBadgeImg(game: any): string {
    let reward = null;
    if (game == undefined) return reward;
    if (game.MultiplierMadnessRewards != null) { reward = null; } // No badges for MM
    else if (game.TopDogRewards != null) { reward = (game.TopDogRewards.length != 0 && game.TopDogRewards[0].Badge != null) ? game.TopDogRewards[0].Badge.rewardValue : null; } // get 1st place reward
    else if (game.BullseyeRewards != null) { reward = (game.BullseyeRewards.length != 0 && game.BullseyeRewards[0].Badge != null) ? game.BullseyeRewards[0].Badge.rewardValue : null; }
    else if (game.Connect3Rewards != null && game.underlyingRule.GameType == 6) { reward = (game.Connect3Rewards.ThreeInRow.length != 0 && game.Connect3Rewards.ThreeInRow != null) ? game.Connect3Rewards.ThreeInRow.badge : null; }
    else if (game.Connect3Rewards != null && game.underlyingRule.GameType == 7) { reward = (game.Connect3Rewards.Blackout.length != 0 && game.Connect3Rewards.Blackout != null) ? game.Connect3Rewards.Blackout.badge : null; }
    else if (game.MilestoneRewards != null && game.MilestoneRewards.length > 0) { reward = (game.MilestoneRewards[0].Badge != null) ? game.MilestoneRewards[game.MilestoneRewards.length - 1].Badge.rewardValue : null; }
    if (reward == null || reward == 0) return null;
    return "../Admin/ImageResizer.aspx?imgid=" + reward + "&w=24&h=24";
  }

  getBracketBadge(rewards: any): string {
    let reward = null;
    if (rewards) {
      reward = (rewards && rewards.Badge != null) ? rewards.Badge.rewardValue : null;
    }
    if (reward == null || reward == 0) return null;
    return "../Admin/ImageResizer.aspx?imgid=" + reward + "&w=24&h=24";
  }

  getActiveText(currentText: string): string {
    let activeText = "";

    if(currentText.includes("Continuously running")){
      activeText = currentText.replace("Continuously running", this.gamesService.getLocalizedMessage("Continuously_Running", "Continuously running"));
    } else if (currentText.includes("Runs till")){
      activeText = currentText.replace("Continuously running", this.gamesService.getLocalizedMessage("Runs_Till", "Runs till"));
    } else if (currentText.includes("Ended on")){
      activeText = currentText.replace("Continuously running", this.gamesService.getLocalizedMessage("Ended_On", "Ended on"));
    } else if (currentText.includes("Deactivated on")){
      activeText = currentText.replace("Continuously running", this.gamesService.getLocalizedMessage("Deactivated_on", "Deactivated on"));
    } else if (currentText.includes("Final will be on")){
      activeText = currentText.replace("Final will be on", this.gamesService.getLocalizedMessage("Final_will_Be_On", "Final will be on"));
    } else {
      activeText = currentText;
    }

    return activeText;
  }

  async loadPermissionList() {
    if (!this.cvConfigurationService.isCxOne) {
      return;
    }
    await this.pointStorePermissionService.loadPermission(
      this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab)
    );
  }

  hasPermission(permission: string): boolean {
    return this.pointStorePermissionService.checkPermission(permission,
      this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
    );
  }
}
